import {Box, Tabs, Tab} from "@mui/material";
import * as React from 'react';
import TabPanel from "../../../../share/components/tab/TabPanel";
import { User } from "../../../types/models/User";
import UserAddressListItem from "../../../../address/components/userAddress/UserAddressList/UserAddressListItem";
import UserSessionListItem from "../../../../auth/components/userSession/UserSessionList/UserSessionListItem";
import BuyerUserListItem from "../../../../timber/components/buyerUser/BuyerUserList/BuyerUserListItem";
import MembersGroupUserListItem from "../../../../auth/components/membersGroupUser/MembersGroupUserList/MembersGroupUserListItem";
import ContractorUserListItem from "../../../../timber/components/contractorUser/ContractorUserList/ContractorUserListItem";
import ProviderUserListItem from "../../../../timber/components/providerUser/ProviderUserList/ProviderUserListItem";
import AccountingUserListItem from "../../../../timber/components/accountingUser/AccountingUserList/AccountingUserListItem";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";

type IFormProps = {
    data: User;
};

const UserTabs: React.FC<IFormProps> = ({ data = {} }) => {

    const session = useStateSession()
    const searchParams = new URLSearchParams(window.location.search)

    const [tabValue, setTabValue] = React.useState(searchParams.get('tab') || 'userAddress');
    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        
        if (searchParams.has('tab')) {
            searchParams.set('tab', newValue)
        } else {
            searchParams.append('tab', newValue)
        }
        window.history.pushState({}, '', '?' + searchParams.toString())

        setTabValue(newValue);
    };

    return (
        <Box sx={ { width: '100%' } }>
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                data-testid="User-tabs"
            >
                { session.hasPermission('', 'applications/auth/entities/UserAddresses/list/view') &&
                    <Tab label={t`User Addresses`} value="userAddress"/>
                }
                { session.hasPermission('', 'applications/auth/entities/UserSessions/list/view') &&
                    <Tab label={t`User Sessions`} value="userSession"/>
                }
                { session.hasPermission('', 'applications/auth/entities/BuyerUsers/list/view') &&
                    <Tab label={t`Buyer Users`} value="buyerUser"/>
                }
                { session.hasPermission('', 'applications/auth/entities/MembersGroupUsers/list/view') &&
                    <Tab label={t`Members Group Users`} value="membersGroupUser"/>
                }
                { session.hasPermission('', 'applications/auth/entities/ContractorUsers/list/view') &&
                    <Tab label={t`Contractor Users`} value="contractorUser"/>
                }
                { session.hasPermission('', 'applications/auth/entities/ProviderUsers/list/view') &&
                    <Tab label={t`Provider Users`} value="providerUser"/>
                }
                { session.hasPermission('', 'applications/auth/entities/AccountingUsers/list/view') &&
                    <Tab label={t`Accounting Users`} value="accountingUser"/>
                }
                </Tabs>
            
            { session.hasPermission('', 'applications/auth/entities/UserAddresses/list/view') &&
                <TabPanel value={tabValue} index="userAddress" data-testid="UserAddress-tab">
                    <UserAddressListItem userId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/auth/entities/UserSessions/list/view') &&
                <TabPanel value={tabValue} index="userSession" data-testid="UserSession-tab">
                    <UserSessionListItem userId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/auth/entities/BuyerUsers/list/view') &&
                <TabPanel value={tabValue} index="buyerUser" data-testid="BuyerUser-tab">
                    <BuyerUserListItem userId={data?.id} showAdd={ false } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/auth/entities/MembersGroupUsers/list/view') &&
                <TabPanel value={tabValue} index="membersGroupUser" data-testid="MembersGroupUser-tab">
                    <MembersGroupUserListItem userId={data?.id} showAdd={ true } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/auth/entities/ContractorUsers/list/view') &&
                <TabPanel value={tabValue} index="contractorUser" data-testid="ContractorUser-tab">
                    <ContractorUserListItem userId={data?.id} showAdd={ false } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/auth/entities/ProviderUsers/list/view') &&
                <TabPanel value={tabValue} index="providerUser" data-testid="ProviderUser-tab">
                    <ProviderUserListItem userId={data?.id} showAdd={ false } />
                </TabPanel>
            }
            { session.hasPermission('', 'applications/auth/entities/AccountingUsers/list/view') &&
                <TabPanel value={tabValue} index="accountingUser" data-testid="AccountingUser-tab">
                    <AccountingUserListItem userId={data?.id} showAdd={ false } />
                </TabPanel>
            }
            
        </Box>
    )
}

export default UserTabs;
